import type { Locale } from "@i18n/react";

import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";
import type { SearchItemType } from "./types/enums/searchItemTypeEnum.enums";

export type KeySearchProps = {
  filters: {
    excludedCategories?: string[];
    locale: Locale;
    type?: SearchItemType;
  };
  isKidAccount?: boolean;
  search: string;
};

export const keySearch: BaseKeyFunction<KeySearchProps> = ({
  filters,
  isKidAccount,
  search,
}) => ["search", filters, search, { isKidAccount: isKidAccount ?? false }];
